"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialNetwork = void 0;
var SocialNetwork;
(function (SocialNetwork) {
    SocialNetwork["Discord"] = "discord";
    SocialNetwork["Facebook"] = "facebook";
    SocialNetwork["Instagram"] = "instagram";
    SocialNetwork["Twitch"] = "twitch";
    SocialNetwork["Youtube"] = "youtube";
    SocialNetwork["Twitter"] = "twitter";
    SocialNetwork["Tiktok"] = "tiktok";
    SocialNetwork["Telegram"] = "telegram";
    SocialNetwork["Medium"] = "medium";
    SocialNetwork["Github"] = "github";
})(SocialNetwork = exports.SocialNetwork || (exports.SocialNetwork = {}));
//# sourceMappingURL=social-network.js.map